const $inject = ['$filter', 'moment', 'ENUMS', 'dateTimeService'];

const lbTripOptionCarFormItemCtrl = function ($filter, moment, ENUMS, dateTimeService) {
  let vm = this;

  const timeFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);

  vm.flightDateTimeFormat = `DD MMM[,] YYYY ${timeFormat}`;
};

lbTripOptionCarFormItemCtrl.$inject = $inject;

export default lbTripOptionCarFormItemCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsCarFormItemCtrl.js